<template>
   <div class="pt-[16px] px-[24px] max-w-full">
    <ul class="flex bg-[#2B2C32] rounded-full px-8 py-1 mb-1">
      <li :class="'mr-4 uppercase' + (active == 'regular' ? ' active' : '')">
        <router-link :to="{ name: 'ProductCategories' }" href="#" class="inline-block text-theme-white tracking-widest text-sm text-white font-semibold px-2">
          REGULAR CATEGORIES
        </router-link>
      </li>
      <li :class="active == 'featured' ? ' active' : ''">
        <router-link :to="{ name: 'ProductFeaturedCategories' }" class="text-theme-theme-white text-white tracking-widest text-sm font-semibold">
         FEATURED CATEGORIES
        </router-link>
      </li>
    </ul>
  </div>
</template>
<script lang="ts">
import {defineComponent, ref} from "vue"

export default defineComponent({
  props: {
    active: {
      required: true,
      type: String,
    },
    callback: {
      required: true,
      type: Function,
    }
    
  }
})
</script>

<style scoped>
  .active:before {
    content: '';
    position: absolute;
    background: #2BA66B;
    width: 100%;
    height: 4px;
    bottom: -8px;
  }
  .active {
    position:relative;
  }
</style>